import nestAxios from './_nestAxios'
import axios from './_inveAxios'

export const obtenerAsSelect = () => nestAxios.get('/companias', { params: { tipoConsulta: 'select' } })

export const getCompania = () => nestAxios.get(`/companias/info`)

export const getEstructuras = () => nestAxios.get(`/companias/estructuras`)

export const getCuentasRetencionPercepcion = () =>
  nestAxios.get(`/companias/info`, {
    params: {
      tipoConsulta: 'retencionPercepcion'
    }
  })

export const actualizarCompania = data => nestAxios.put('/companias', data)

export const actualizarEstructuras = data => nestAxios.put('/companias/estructuras', data)

export const nuevaCompania = data => nestAxios.post('/companias', data)

export const insertarActualizarCompaniaConfiguracion = data => axios.post('/companias/compania-configuracion', data)

export const obtenerCompaniaConfiguracion = () => axios.get('/companias/compania-configuracion')

